import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle 
} from '../ui/dialog';
import { CheckCircle2, Package } from 'lucide-react';

export default function ConcluirTarefaModal({
  open,
  onOpenChange,
  tarefa,
  conclusao,
  onConclusaoChange,
  onConfirmar,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-green-600" />
            Concluir Tarefa
          </DialogTitle>
        </DialogHeader>

        {tarefa && (
          <div className="space-y-4 mt-4">
            {/* Info da tarefa */}
            <div className="p-4 bg-purple-50 rounded-xl border border-purple-100">
              <h4 className="font-semibold text-stone-800 mb-2">{tarefa.nome}</h4>

              {(tarefa.marca || tarefa.modelo) && (
                <p className="text-sm text-stone-600 mb-2">
                  {tarefa.marca && <span className="font-medium">{tarefa.marca}</span>}
                  {tarefa.marca && tarefa.modelo && ' · '}
                  {tarefa.modelo}
                </p>
              )}

              <div className="flex flex-wrap gap-1.5">
                {(tarefa.operacoes || []).map((op, idx) => (
                  <span key={idx} className="text-sm px-3 py-1.5 bg-white text-primary rounded-lg border border-primary/20 font-bold">
                    {op.operacao_codigo} - {op.operacao_nome}
                  </span>
                ))}
              </div>

              {tarefa.observacoes && (
                <p className="text-xs text-stone-500 italic mt-2 pt-2 border-t border-purple-100">
                  "{tarefa.observacoes}"
                </p>
              )}
            </div>

            {/* Campo quantidade — só se a tarefa obriga contagem */}
            {tarefa.obriga_contagem ? (
              <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">
                  Quantidade Produzida <span className="text-red-500">*</span>
                </label>
                <Input
                  type="number"
                  placeholder="Quantas peças fez?"
                  value={conclusao.quantidade}
                  onChange={(e) => onConclusaoChange({ ...conclusao, quantidade: e.target.value })}
                  className="text-xl h-14 text-center font-semibold"
                  autoFocus
                  data-testid="tarefa-quantidade-input"
                />
              </div>
            ) : (
              <div className="p-3 bg-stone-50 border border-stone-200 rounded-lg flex items-start gap-2" data-testid="tarefa-sem-contagem-info">
                <Package className="h-4 w-4 text-stone-500 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-stone-600">
                  Esta tarefa não exige contagem de peças. Confirme para registar a conclusão.
                </p>
              </div>
            )}

            <div className="flex gap-3 pt-4">
              <Button
                variant="outline"
                className="flex-1 h-12 rounded-xl"
                onClick={() => onOpenChange(false)}
              >
                Cancelar
              </Button>
              <Button
                className="flex-1 h-12 rounded-xl bg-green-600 hover:bg-green-700"
                onClick={onConfirmar}
                disabled={tarefa.obriga_contagem && (!conclusao.quantidade || parseInt(conclusao.quantidade) <= 0)}
                data-testid="confirmar-conclusao-tarefa"
              >
                <CheckCircle2 className="h-4 w-4 mr-2" />
                Confirmar
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
